<template>
  <section class="regulation">
    <div class="container">
      <h1 class="ttl regulation__title">Regras de Uso</h1>
      <p class="regulation__text">Confira as regras e veja como aproveitar ao máximo o Programa de Afiliados do Melhor Envio.</p>

      <h3 class="regulation__subtitle">Regras</h3>
      <ul class="regulation__list">
        <li>
          Quem usa o Melhor Envio tem acesso a um <strong>link de afiliado</strong> que fica disponível
          no menu Afiliados do Painel de Controle. Você pode compartilhar seu link para divulgar a nossa plataforma.
        </li>
        <li>
          Quando alguém se cadastrar usando o seu link, você passa a <strong>receber uma comissão de R$ 0,25</strong>
          a cada envio que essa pessoa fizer durante 1 ano.
        </li>
        <li>
          Cada pessoa que usar o Programa de Afiliados deve ter uma <strong>única conta no Melhor Envio</strong>.
          Se identificarmos mais de uma conta para a mesma pessoa, as contas serão bloqueadas e as comissões
          serão retidas pela plataforma.
        </li>
      </ul>

      <h3 class="regulation__subtitle">Resgate da comissão</h3>
      <ul class="regulation__list">
        <li>
          A comissão fica disponível após o envio da pessoa cadastrada ser confirmado pelo sistema.
          O envio será confirmado <strong>após o pagamento da etiqueta e a postagem do pacote.</strong>
        </li>
        <li>
          <strong>O valor mínimo para resgate da comissão é R$ 25,00.</strong>
          Após solicitação de resgate, a comissão disponível será automaticamente
          creditada na sua <a :href="$sanitizeUrl($options.static.INTERNAL_LINKS.WALLET.HOME)">Melhor Carteira</a>
        </li>
        <li>
          Você pode usar o valor resgatado para pagar seus fretes ou solicitar o saque para sua conta-corrente.
        </li>
      </ul>

      <p class="regulation__text">
        Nos reservamos o direito de alterar as regras do Programa de Afiliados com aviso por e-mail
        30 dias antes das alterações entrarem em vigor.
      </p>
    </div>
  </section>
</template>

<script>
import { INTERNAL_LINKS } from 'commons/js/enums/links';

export default {
  static: {
    INTERNAL_LINKS
  }
}
</script>
